import { canUserEditPage } from '@gik/inkind-page/utils/inkindPagePermissions';
import React from 'react';
import WishlistIcon from '@gik/wishlist-page/assets/icon-wishlist.svg';
import { translationKeys } from './i18n/en';
import { Button, FontIcon, KeepProportions, ProportionSetting, SvgIcon } from '@gik/ui';
import bemBlock from '@gik/core/utils/bemBlock';
import { useInkind } from '@gik/api/inkinds/inkind';
import { useTranslation } from 'react-i18next';
import { useUserStore } from '@gik/core/store/UserStore';
import Link from '@/components/Link';

interface IWishlistEmptyStateProps {
  inkindRouteId: string;
  proportion?: ProportionSetting;
}

export default function WishlistEmptyState({ inkindRouteId, proportion }: IWishlistEmptyStateProps) {
  const userStore = useUserStore();
  const userId = userStore.id;

  const { data: inkindPage } = useInkind(inkindRouteId);
  const canEdit = canUserEditPage(inkindPage, userId);
  const bem = bemBlock('wishlist-empty');
  const { t } = useTranslation();

  return (
    <KeepProportions proportion={proportion}>
      <div className={bem()}>
        <WishlistIcon />
        <span className={`${bem('title')}`}>{t(translationKeys.empty)}</span>
        {canEdit && (
          <>
            <p>
              Add to your wishlist by
              <br /> clicking the “<SvgIcon className={`${bem('plus-icon')}`} size="xl" name="PlusOutline" />“ on items
            </p>

            <Link href={inkindPage?.inkindSituations[0].giftingUrl}>
              <Button variant="secondary" prepend={<FontIcon size="lg" name="wishlist" />}>
                {t(translationKeys.findWishlistIdeas)}
              </Button>
            </Link>
          </>
        )}
      </div>
    </KeepProportions>
  );
}
